import { Action } from '@ngrx/store';
import { IdentityActions, IdentityActionTypes } from './identity.actions';
import { Identity } from './identity.model';

export type IdentityState = Identity | undefined;
const initialState: IdentityState = undefined;

export function reducer(state = initialState, incomingAction: Action): IdentityState {
  const action: IdentityActions = incomingAction as IdentityActions;
  switch (action.type) {
    case IdentityActionTypes.IdentityLoaded: {
      return action.payload.identity;
    }
    default: {
      return state;
    }
  }
}
